<!--
 * @Descripttion: 
 * @Author: 苍狼一啸八荒惊
 * @Date: 2024-09-02 16:19:20
 * @LastEditTime: 2025-07-16 16:21:35
 * @LastEditors: sudo_rm_rf
-->
<script lang="ts" setup>
import HeaderLanguage from './language.vue';
import HeaderScreenFull from './screenFull.vue';
// import HeaderTheme from './theme.vue';
import { encrypt, decrypt } from '/@/utils/cryptoJs';
import { setCookie, getCookie, removeCookie, events } from '/@/utils';
import { useRouter, useRoute } from 'vue-router';
import logo from '/@/assets/imgs/mlva.png';
import { useUser, usePermissionStore } from '/@/store/index';
import { Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { createVNode } from 'vue';
const router = useRouter();
const route = useRoute();
import headerMenuDev from './headerMenuDev';
// import router from '/@/router';
const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: '柏炬建库仪上位机',
  },
  showMenu: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
});

const routerPath = computed(() => router.currentRoute.value.path);
const userName = ref((localStorage.getItem('userName') && localStorage.getItem('userName')?.slice(0, 4) + '...') || '');
const userNameAll = ref((localStorage.getItem('userName') && localStorage.getItem('userName')) || '');

onMounted(() => {
  // console.log(route.path);
});

import { MenuProps } from 'ant-design-vue';
// const current = ref<string[]>(JSON.parse(localStorage.getItem('menuCurrent') || '["/homePage"]'));
const current = ref<string[]>([`/${route.path.split('/').pop()}`] || ['/homePage']);
const items = ref<MenuProps['items']>(usePermissionStore().menusItem);
// const items = headerMenuDev;

const headerActiveKey = (data: any) => {
  current.value = [data];
  events.off('headerActiveKey', headerActiveKey);
};
events.on('headerActiveKey', headerActiveKey);

const handleMenu = (e: any) => {
  let { key, item } = e;
  localStorage.setItem('menuCurrent', JSON.stringify([e.key]));
  let { path } = item;
  router.push(path);
};

const userInfo = () => {
  message.info('个人信息');
};
const logout = () => {
  post('/auth/logout').then((res: any) => {
    useUser().setRoles([]);
    localStorage.removeItem('userName');
    removeCookie('TOKEN');
    router.push('/login');
    // setCookie('TOKEN', res);
  });
};

// window.addEventListener('hashchange', function (e) {
//   message.info('我监听到了浏览器的返回按钮事件啦');
//   alert('我监听到了浏览器的返回按钮事件啦'); //根据⾃⼰的需求实现⾃⼰的功能
// });
</script>

<template>
  <div class="header-contanier flex-center relative">
    <h1 class="position-center">柏炬科技上位机</h1>
    <div class="flex-between w-100%">
      <!-- {{ useUser().roles }}
      {{ useUser().permissions }} -->
      <!-- <div class="title font-size-20 cursor-pointer flex-center" @click="() => router.push('/index')">
        <span class='w-50px h-50px'><img border-rd-2xl w-100% h-100% :src="logo" alt="" srcset="" /></span>
        <span>{{ title }}</span>
      </div> -->
      <div>
        <a-menu v-if="showMenu" v-model:selectedKeys="current" mode="horizontal" :items="items" @click="handleMenu" />
      </div>
      <div class="flex-center">
        <a-space>
          <HeaderScreenFull />
          <!-- <HeaderTheme /> -->
          <HeaderLanguage />
          <a-tooltip v-if="userName && getCookie('TOKEN')" placement="bottom">
            <template #title>
              <span>退出登录</span>
            </template>
            <span class="w-30px h-30px" i-ant-design-poweroff-outlined cursor-pointer @click="logout" />
          </a-tooltip>

          <!-- <a-dropdown placement="bottomRight" v-if="userName && getCookie('TOKEN')">
            <span class="font-size-18 mt-1 vertical--25%" @click.prevent :title="userNameAll">
              {{ userName }}
            </span>
            <template #overlay>
              <a-menu>
                <a-menu-item class="locale-menu-item">
                  <a class="locale-item" href="javascript:;" @click="logout">退出登录</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown> -->
        </a-space>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.header-contanier {
  height: 56px;
  padding: 0px 3%;
  // background-color: var(--bg-color);
  background-color: #00a9bb;
  color: #fff;
  border-radius: 5px;
  // background-image: linear-gradient(to left, #40e0d0 0%, #0c4843 100%);
}
.active {
  font-weight: 600;
  color: #073d32 !important;
  &:hover {
    color: #0d665f !important;
  }
  span {
    cursor: pointer;
    color: #073d32;
    &:hover {
      color: #0d665f;
    }
  }
}
.ant-btn-link {
  color: #fff;
  font-size: 18px;
  &:hover {
    color: #0d665f;
  }
  span {
    &:hover {
      color: #0d665f !important;
    }
  }
}
span {
  cursor: pointer;
  color: #fff;
}
:deep(.ant-menu) {
  .ant-menu-item,
  .ant-menu-submenu {
    font-size: 20px;
  }
}
.onsdf {
}
</style>
<style lang="less">
// 这个要将  a-menu 拆开写  用  popup-class-name  样式渗透  或者写全局样式  scoped
// <a-menu>
//   <a-sub-menu popup-class-name="custom-popup">
//     <template #title>子菜单</template>
//     <a-menu-item>选项1</a-menu-item>
//   </a-sub-menu>
// </a-menu>

// .ant-menu-item-disabled {
//   display: none !important;
// }
//
</style>
